import accueilJson from "./accueil.json";

/**
 * ============================================================================
 *  choix.ts — Les choix proposés au lancement de la visite
 * ----------------------------------------------------------------------------
 *  Le menu de l'écran d'accueil vit dans `accueil.json`, jamais dans le code :
 *  l'ordre des items, leurs textes, le parcours qu'ils lancent. Ce module ne
 *  fait que les typer.
 *
 *  Un item est soit la VISITE LIBRE (`mode: "libre"`), soit un PARCOURS narratif
 *  (`mode: "parcours"`) qui enchaîne les chapitres d'une timeline, désignée par
 *  son nom (`parcours`, voir `parcours.ts`), soit les CRÉDITS (`mode: "credits"`),
 *  qui n'ouvrent pas la visite mais un panneau.
 *
 *  Les textes de l'interface de l'accueil (bienvenue, signature, libellés de
 *  chargement) sont dans le même fichier : une seule source pour l'écran.
 * ==========================================================================*/

type Texte = Record<string, string>;

export interface Item {
  id: string;
  mode: string;
  parcours?: string;
  titre: Texte;
  /** Une ligne, sous l'item actif. Absent : l'item n'en montre pas. */
  sousTitre?: Texte;
}

export interface Accueil {
  /** Échelle maximale (1 = aucun zoom) du zoom lent du panorama de fond, tant que l'accueil est affiché. */
  zoomEchelle: number;
  /** Durée d'un cycle complet zoom puis dézoom, en secondes. */
  zoomPeriodeSecondes: number;
  bienvenue: Texte;
  son: Texte;
  signature: Texte;
  chargement: Texte;
  pret: Texte;
  entree: Texte;
  langue: Texte;
  bientot: Texte;
  retour: Texte;
  retourTitre: Texte;
  /** Infobulle du logo du bandeau, qui ramène à la première scène. */
  logoTitre: Texte;
  items: Item[];
}

export const accueil: Accueil = accueilJson;

export const estParcours = (item: Item): boolean => item.mode === "parcours" && item.parcours !== undefined;

export const estCredits = (item: Item): boolean => item.mode === "credits";
